<template>
  <div>                                 
    <v-row>
      <v-col cols="12" sm="12" md="4" lg="4" v-if="type === 'IMS'">
        IG Static<br/>
        <strong>{{(data.igStatic ? data.igStatic : '-')}}</strong>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        IG Carousel<br/>
        <strong>{{(data.igCarousel ? data.igCarousel : '-')}}</strong>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        IG Story<br/>
        <strong>{{(data.igStory ? data.igStory : '-')}}</strong>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4" v-if="type === 'rateCard'">
        IG Post<br/>
        <strong>{{(data.igPost ? data.igPost : '-')}}</strong>
      </v-col>
      <!-- <v-col cols="12" sm="12" md="4" lg="4" v-if="type === 'rateCard'">
        IG Video<br/>
        <strong>{{(data.igVideo ? data.igVideo : '-')}}</strong>
      </v-col> -->
      <v-col cols="12" sm="12" md="4" lg="4" v-if="type === 'rateCard'">
        IG Reel<br/>
        <strong>{{(data.igReel ? data.igReel : '-')}}</strong>
      </v-col>
      <!-- <v-col cols="12" sm="12" md="4" lg="4">
        IG TV<br/>
        <strong>{{(data.igTv ? data.igTv : '-')}}</strong>
      </v-col> -->
      <v-col cols="12" sm="12" md="4" lg="4" v-if="type === 'IMS'">
        Blog<br/>
        <strong>{{(data.blog ? data.blog : '-')}}</strong>
      </v-col>
      <v-col cols="12" sm="12" md="8" lg="8" v-if="type === 'rateCard'">
        Event Appearance <br/>
        <strong>{{(data.eventAppearance ? data.eventAppearance : '-')}}</strong>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        Tiktok<br/>
        <strong>{{(data.tiktok ? data.tiktok : '-')}}</strong>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12">
        Loading Fee<br/>
        <strong>{{(data.loadingFee ? data.loadingFee : '-')}}</strong>
      </v-col>
    </v-row>                              
    <v-row>                                      
    </v-row>
    <v-row v-if="type === 'rateCard'">
      <v-col cols="12" sm="12" md="12" lg="12">
        IG Remarks<br/>
        <strong>{{(data.igRemarks ? data.igRemarks : '-')}}</strong>
      </v-col>                                      
    </v-row>
    <v-row v-if="type === 'rateCard'">
      <v-col cols="12" sm="12" md="12" lg="12">
        Tiktok Remarks<br/>
        <strong>{{(data.tiktokRemarks ? data.tiktokRemarks : '-')}}</strong>
      </v-col>                                      
    </v-row>
    <v-row v-if="type === 'IMS'">
      <v-col cols="12" sm="12" md="12" lg="12">
        Remark<br/>
        <strong v-if="data.remark">{{(data.remark ? data.remark : '-')}}</strong>
        <strong v-if="data.remarks">{{(data.remarks ? data.remarks : '-')}}</strong>
      </v-col>                                      
    </v-row>
    <v-row v-if="data.pricingDecks && data.pricingDecks.length > 0">
      <v-col cols="12" sm="12">
        <label>Pricing Decks</label>
        <file-preview :files="data.pricingDecks" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import FilePreview from '@/components/scoped/custom/FilePreview';
export default {
  name: 'RateCardPreview',
  components: {
    FilePreview
  },
  props: ['data', 'type']
}
</script>



// WEBPACK FOOTER //
// Preview.vue?4e71ac6e